import { useSyncExternalStore } from "react";

/**
 * Light, Dark or Match my system (ALN-25). Kept per browser; "system" removes data-theme so the
 * prefers-color-scheme rules in tokens.css decide.
 */
export type Theme = "light" | "dark" | "system";
const KEY = "vintner.theme";
const listeners = new Set<() => void>();

function read(): Theme {
  try {
    const v = localStorage.getItem(KEY);
    return v === "light" || v === "dark" ? v : "system";
  } catch {
    return "system";
  }
}

export function applyTheme(t: Theme = read()): void {
  const root = document.documentElement;
  if (t === "system") root.removeAttribute("data-theme");
  else root.setAttribute("data-theme", t);
}

export function setTheme(t: Theme): void {
  try {
    if (t === "system") localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, t);
  } catch {
    /* private mode: the choice lasts for this page */
  }
  applyTheme(t);
  current = t;
  listeners.forEach(l => l());
}

let current: Theme = typeof window === "undefined" ? "system" : read();

export function useTheme(): Theme {
  return useSyncExternalStore(cb => { listeners.add(cb); return () => listeners.delete(cb); }, () => current, () => "system");
}
